module.exports = __webpack_public_path__ + "img/panel4.e09a5ae0.svg";